import { useTranslation } from 'react-i18next'

import { downloadFileByUrl } from '../../../../utils/file'
import Button, { BUTTON_HEIGHT_32 } from '../../../Button'
import Text from '../../../Text'
import { DOC_FLOW_EPOST_VALIDATION_PREVIEW_TITLE_KEY } from '../DocFlowEpostValidationPreviewModal.constants'

import { QA_NAME_DOC_FLOW_EPOST_VALIDATION_PREVIEW_DOWNLOAD_BUTTON } from './DocFlowEpostValidationPreviewImage.constants'

import * as styles from './DocFlowEpostValidationPreviewImage.module.css'

import ExportIcon from '../../../../icons/export.svg'

function DocFlowEpostValidationPreviewImage({ fileName, src }) {
  const { t } = useTranslation()

  function handleDownload() {
    downloadFileByUrl(src, fileName)
  }

  return (
    <div className={styles.DocFlowEpostValidationPreviewImage}>
      <div className={styles.header}>
        <Text isSecondary>
          {t('DocFlow.EpostValidationPreviewImageTextKey')}
        </Text>

        <Button.Outlined
          isGrey
          beforeIconProps={{ Icon: ExportIcon }}
          className={styles.downloadButton}
          height={BUTTON_HEIGHT_32}
          qaName={QA_NAME_DOC_FLOW_EPOST_VALIDATION_PREVIEW_DOWNLOAD_BUTTON}
          text={t('Files.DownloadBtnKey')}
          onClick={handleDownload}
        />
      </div>

      <img
        alt={t(DOC_FLOW_EPOST_VALIDATION_PREVIEW_TITLE_KEY)}
        className={styles.image}
        src={src}
      />
    </div>
  )
}

export default DocFlowEpostValidationPreviewImage
